import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/HomePage.vue'
import AgendaPage from '../views/AgendaPage.vue'
import ContactPage from '../views/ContactPage.vue'
import MediaPage from '../views/MediaPage.vue'
import StartupZonePage from '../views/StartupZonePage.vue'
import ExhibitPage from '../views/ExhibitPage.vue'
import PartnersPage from '../views/PartnersPage.vue'
import FormFillPage from '../views/FormFillPage.vue'
import FormBuilderPage from '../views/FormBuilderPage.vue'
import FormSubmissionsPage from '../views/FormSubmissionsPage.vue'
import DynamicFormPage from '../views/DynamicFormPage.vue'
import FormResponsesPage from '../views/FormResponsesPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/agenda',
    name: 'Agenda',
    component: AgendaPage
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage
  },
  {
    path: '/media',
    name: 'Media',
    component: MediaPage
  },
  {
    path: '/startup-zone',
    name: 'StartupZone',
    component: StartupZonePage
  },
  {
    path: '/exhibit',
    name: 'Exhibit',
    component: ExhibitPage
  },
  {
    path: '/partners',
    name: 'Partners',
    component: PartnersPage
  },
  {
    path: '/form-fill',
    name: 'FormFill',
    component: FormFillPage
  },
  {
    path: '/form-builder',
    name: 'FormBuilder',
    component: FormBuilderPage
  },
  {
    path: '/form/:id',
    name: 'DynamicForm',
    component: DynamicFormPage
  },
  {
    path: '/form-responses/:id',
    name: 'FormResponses',
    component: FormResponsesPage
  },
  {
    path: '/submissions',
    name: 'FormSubmissions',
    component: FormSubmissionsPage
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
